import React from "react";
import { getAssetUrl } from "../../../modules/shared/utilities/AppConfig";

const BTNCLOActivitiesContent = () => {
  const monevRegions = [
    { name: "Monev Aceh", region: "Aceh", status: "Terlaksana" },
    { name: "Monev Kaltara", region: "Kalimantan Utara", status: "Terlaksana" },
    { name: "Monev Kalbar", region: "Kalimantan Barat", status: "Terlaksana" },
    { name: "Monev Sumut", region: "Sumatera Utara", status: "Terlaksana" },
    { name: "Monev Sulut", region: "Sulawesi Utara", status: "Terlaksana" },
  ];

  const assistanceRegions = [
    { name: "Polda Papua", region: "Papua", status: "Ongoing" },
    {
      name: "Polda Kepulauan Riau",
      region: "Kepulauan Riau",
      status: "Ongoing",
    },
  ];

  return (
    <div className="p-8">
      <div className="space-y-8">
        {/* Overview Section */}
        <div className="bg-base-200 rounded-xl p-6">
          <h2 className="text-2xl font-bold mb-6">Kegiatan BTNCLO</h2>
          <div className="bg-base-100 rounded-lg p-6">
            <p className="text-base-content/70 leading-relaxed">
              BTNCLO melaksanakan berbagai kegiatan untuk mendukung
              penanggulangan kejahatan transnasional di wilayah perbatasan
              melalui monitoring, evaluasi, pembimbingan, dan asistensi
              berkelanjutan.
            </p>
          </div>
        </div>

        {/* Activity Categories */}
        <div className="bg-base-200 rounded-xl p-6">
          <h2 className="text-2xl font-bold mb-6">Kategori Kegiatan</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-base-100 rounded-lg p-6 text-center">
              <div className="bg-primary rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl">📊</span>
              </div>
              <h3 className="font-semibold text-lg mb-2">Monev BTNCLO</h3>
              <p className="text-sm text-base-content/70">
                Monitoring dan Evaluasi
              </p>
            </div>

            <div className="bg-base-100 rounded-lg p-6 text-center">
              <div className="bg-secondary rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl">🎓</span>
              </div>
              <h3 className="font-semibold text-lg mb-2">Bimtek BTNCLO</h3>
              <p className="text-sm text-base-content/70">Bimbingan Teknis</p>
            </div>

            <div className="bg-base-100 rounded-lg p-6 text-center">
              <div className="bg-accent rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl">🤝</span>
              </div>
              <h3 className="font-semibold text-lg mb-2">Asistensi BTNCLO</h3>
              <p className="text-sm text-base-content/70">
                Pendampingan dan Bantuan
              </p>
            </div>
          </div>
        </div>

        {/* Monitoring & Evaluation */}
        <div className="bg-base-200 rounded-xl p-6">
          <h2 className="text-2xl font-bold mb-6">
            Monitoring dan Evaluasi (Monev)
          </h2>
          <div className="space-y-6">
            {monevRegions.map((region, index) => (
              <div key={index} className="bg-base-100 rounded-lg p-6">
                <div className="flex flex-col lg:flex-row gap-6">
                  {/* Content Section */}
                  <div className="lg:w-2/3">
                    <div className="flex items-center gap-4 mb-4">
                      <div className="bg-primary rounded-full w-12 h-12 flex items-center justify-center flex-shrink-0">
                        <span className="text-primary-content font-semibold">
                          {index + 1}
                        </span>
                      </div>
                      <div>
                        <h3 className="font-semibold text-lg">{region.name}</h3>
                        <p className="text-base-content/70">
                          Wilayah: {region.region}
                        </p>
                      </div>
                      <div className="bg-base-200 rounded-lg px-4 py-2 ml-auto">
                        <span className="font-medium text-sm">
                          {region.status}
                        </span>
                      </div>
                    </div>
                    <p className="text-base-content/70 leading-relaxed">
                      Kegiatan monitoring dan evaluasi untuk memastikan
                      implementasi BTNCLO berjalan sesuai standar dan memberikan
                      hasil yang optimal dalam penanggulangan kejahatan
                      transnasional di wilayah perbatasan.
                    </p>
                  </div>

                  {/* Images Section */}
                  <div className="lg:w-1/3">
                    <div className="grid gap-3">
                      {/* Show 2 images for each Monev region */}
                      {[0, 1].map((imgOffset) => (
                        <div
                          key={imgOffset}
                          className="bg-base-100 rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow"
                        >
                          <img
                            src={getAssetUrl(
                              `/gallery/btnclo/BTNCLO_${index * 2 + imgOffset}.jpg`,
                            )}
                            alt={`${region.name} dokumentasi ${imgOffset + 1}`}
                            loading="lazy"
                            className="w-full h-32 object-cover hover:scale-105 transition-transform duration-300 cursor-pointer"
                            onError={(e) => {
                              const target = e.target as HTMLImageElement;
                              target.src = "/placeholder-image.jpg";
                              target.alt = "Gambar tidak tersedia";
                            }}
                            onClick={() =>
                              window.open(
                                getAssetUrl(
                                  `/gallery/btnclo/BTNCLO_${index * 2 + imgOffset}.jpg`,
                                ),
                                "_blank",
                              )
                            }
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Technical Guidance */}
        <div className="bg-base-200 rounded-xl p-6">
          <h2 className="text-2xl font-bold mb-6">Bimbingan Teknis (Bimtek)</h2>
          <div className="bg-base-100 rounded-lg p-6">
            <div className="flex flex-col lg:flex-row gap-6">
              {/* Content Section */}
              <div className="lg:w-2/3">
                <div className="flex items-start gap-4 mb-4">
                  <div className="bg-secondary rounded-full w-16 h-16 flex items-center justify-center flex-shrink-0">
                    <span className="text-2xl">🎓</span>
                  </div>
                  <div className="flex-1">
                    <h3 className="font-semibold text-lg mb-3">
                      Program Bimbingan Teknis BTNCLO
                    </h3>
                    <p className="text-base-content/70 leading-relaxed mb-4">
                      Program pelatihan dan bimbingan teknis untuk meningkatkan
                      kapasitas personel BTNCLO dalam menangani kejahatan
                      transnasional di wilayah perbatasan.
                    </p>
                  </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="bg-base-200 rounded-lg p-4">
                    <h4 className="font-medium mb-2">Materi Pelatihan</h4>
                    <ul className="text-sm text-base-content/70 space-y-1">
                      <li>• Koordinasi Internasional</li>
                      <li>• Penanganan Kasus Transnasional</li>
                      <li>• Intelijen Kepolisian</li>
                      <li>• Prosedur Operasional</li>
                    </ul>
                  </div>
                  <div className="bg-base-200 rounded-lg p-4">
                    <h4 className="font-medium mb-2">Target Peserta</h4>
                    <ul className="text-sm text-base-content/70 space-y-1">
                      <li>• Personel BTNCLO</li>
                      <li>• Perwira Hubungan Internasional</li>
                      <li>• Anggota Divhubinter</li>
                      <li>• Mitra Kerja Terkait</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* Images Section */}
              <div className="lg:w-1/3">
                <div className="grid gap-3">
                  {/* Bimtek images: BTNCLO_12 and BTNCLO_13 */}
                  {[12, 13].map((imgIndex) => (
                    <div
                      key={imgIndex}
                      className="bg-base-100 rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow"
                    >
                      <img
                        src={getAssetUrl(
                          `/gallery/btnclo/BTNCLO_${imgIndex}.jpg`,
                        )}
                        alt={`Bimtek BTNCLO dokumentasi ${imgIndex - 11}`}
                        loading="lazy"
                        className="w-full h-32 object-cover hover:scale-105 transition-transform duration-300 cursor-pointer"
                        onError={(e) => {
                          const target = e.target as HTMLImageElement;
                          target.src = "/placeholder-image.jpg";
                          target.alt = "Gambar tidak tersedia";
                        }}
                        onClick={() =>
                          window.open(
                            getAssetUrl(
                              `/gallery/btnclo/BTNCLO_${imgIndex}.jpg`,
                            ),
                            "_blank",
                          )
                        }
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Assistance Program */}
        <div className="bg-base-200 rounded-xl p-6">
          <h2 className="text-2xl font-bold mb-6">Program Asistensi</h2>
          <div className="space-y-6">
            {assistanceRegions.map((region, index) => {
              // Image ranges: Papua (14-26), Kepri (27-38)
              const imageStartIndex = index === 0 ? 14 : 27;
              const imageEndIndex = index === 0 ? 26 : 38;
              const imageCount = imageEndIndex - imageStartIndex + 1;

              return (
                <div key={index} className="bg-base-100 rounded-lg p-6">
                  <div className="flex flex-col gap-6">
                    {/* Header */}
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-4">
                        <div className="bg-accent rounded-full w-12 h-12 flex items-center justify-center flex-shrink-0">
                          <span className="text-accent-content font-semibold">
                            {index + 1}
                          </span>
                        </div>
                        <div>
                          <h3 className="font-semibold text-lg">
                            {region.name}
                          </h3>
                          <p className="text-base-content/70">
                            Wilayah: {region.region}
                          </p>
                        </div>
                      </div>
                      <div className="bg-base-200 rounded-lg px-4 py-2">
                        <span className="font-medium text-sm">
                          {region.status}
                        </span>
                      </div>
                    </div>

                    {/* Description */}
                    <p className="text-base-content/70 leading-relaxed">
                      Program asistensi berkelanjutan untuk mendukung
                      implementasi dan optimalisasi BTNCLO di {region.region},
                      meliputi pendampingan teknis, evaluasi operasional, dan
                      peningkatan kapasitas personel.
                    </p>

                    {/* Images Grid */}
                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
                      {Array.from(
                        { length: Math.min(imageCount, 8) },
                        (_, imgIndex) => (
                          <div
                            key={imgIndex}
                            className="bg-base-100 rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow"
                          >
                            <img
                              src={getAssetUrl(
                                `/gallery/btnclo/BTNCLO_${imageStartIndex + imgIndex}.jpg`,
                              )}
                              alt={`Asistensi ${region.region} dokumentasi ${imgIndex + 1}`}
                              loading="lazy"
                              className="w-full h-24 object-cover hover:scale-105 transition-transform duration-300 cursor-pointer"
                              onError={(e) => {
                                const target = e.target as HTMLImageElement;
                                target.src = "/placeholder-image.jpg";
                                target.alt = "Gambar tidak tersedia";
                              }}
                              onClick={() =>
                                window.open(
                                  getAssetUrl(
                                    `/gallery/btnclo/BTNCLO_${imageStartIndex + imgIndex}.jpg`,
                                  ),
                                  "_blank",
                                )
                              }
                            />
                          </div>
                        ),
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="bg-base-100 rounded-lg p-6 mt-6">
            <div className="flex items-start gap-4">
              <div className="bg-primary rounded-full w-16 h-16 flex items-center justify-center flex-shrink-0">
                <span className="text-2xl">🤝</span>
              </div>
              <div className="flex-1">
                <h3 className="font-semibold text-lg mb-3">Bentuk Asistensi</h3>
                <p className="text-base-content/70 leading-relaxed mb-4">
                  Program pendampingan dan bantuan teknis untuk mendukung
                  implementasi BTNCLO di wilayah perbatasan yang membutuhkan
                  perhatian khusus.
                </p>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div className="bg-base-200 rounded-lg p-4 text-center">
                    <h4 className="font-medium mb-2">Pendampingan</h4>
                    <p className="text-sm text-base-content/70">
                      Supervisi dan bimbingan langsung
                    </p>
                  </div>
                  <div className="bg-base-200 rounded-lg p-4 text-center">
                    <h4 className="font-medium mb-2">Bantuan Teknis</h4>
                    <p className="text-sm text-base-content/70">
                      Dukungan operasional dan teknis
                    </p>
                  </div>
                  <div className="bg-base-200 rounded-lg p-4 text-center">
                    <h4 className="font-medium mb-2">Evaluasi</h4>
                    <p className="text-sm text-base-content/70">
                      Penilaian dan perbaikan berkelanjutan
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BTNCLOActivitiesContent;
